// ═══════════════════════════════════════════════════════════
// 通用工具函数
// ═══════════════════════════════════════════════════════════

// HTML 安全转义
export function esc(str) {
    if (!str) return '';
    return str.toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/\//g, '/');
}

// 安全截断
export function truncate(str, maxLen = 50) {
    if (!str) return '';
    const s = str.toString();
    return s.length > maxLen ? s.substring(0, maxLen) + '...' : s;
}

// 相对时间格式化（中文）
export function timeAgo(timestamp) {
    const diff = Date.now() - timestamp;
    const min = Math.floor(diff / 60000);
    if (min < 1) return '刚刚';
    if (min < 60) return `${min}分钟前`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}小时前`;
    const d = Math.floor(hr / 24);
    if (d < 30) return `${d}天前`;
    return new Date(timestamp).toLocaleDateString('zh-CN');
}

// URL 安全校验
export function isValidUrl(url) {
    if (!url) return false;
    return url.startsWith('http://') || url.startsWith('https://');
}

// 生成安全的 DOM ID
export function safeId(str) {
    if (!str) return '';
    return str.toString().replace(/[^\w-]/g, '');
}

// 从备注文本推断标签
export function inferTag(remarks) {
    if (!remarks) return null;
    const r = remarks.toString();
    if (/高清|4K|4k|蓝光|超清|HD/.test(r)) return { text: r, cls: 'hd' };
    if (/新|更新|连载/.test(r)) return { text: r, cls: 'new' };
    return { text: r, cls: '' };
}

// 提取评分
export function extractRating(item) {
    const ds = parseFloat(item.vod_douban_score);
    if (ds && ds > 0) return { val: ds.toFixed(1), src: 'douban' };
    const s = parseFloat(item.vod_score);
    if (s && s > 0) return { val: s.toFixed(1), src: 'site' };
    return null;
}

// 渲染剧集按钮网格（app 和 player 共用）
export function renderEpisodeButtons(episodes, currentIndex, reversed, onClickHandlerName = 'onEpisodeClick') {
    const list = reversed ? [...episodes].reverse() : episodes;
    return list.map((episode, displayIdx) => {
        const realIndex = reversed ? episodes.length - 1 - displayIdx : displayIdx;
        const isActive = realIndex === currentIndex;
        const safeUrl = episode && isValidUrl(episode)
            ? episode.replace(/"/g, '&quot;')
            : '';
        return `
            <button id="ep-${realIndex}"
                    data-index="${realIndex}"
                    data-url="${safeUrl}"
                    class="episode-btn ${isActive ? 'episode-active' : ''}">
                第${realIndex + 1}集
            </button>`;
    }).join('');
}
